module.exports = __webpack_public_path__ + "img/sort-unselected.2b78701a.svg";